import React from "react";
import { GpsFilteredData, HrData, MatchPhone } from "refsix-js-models";

type MatchDebugProps = {
    match: MatchPhone;
    gpsData?: GpsFilteredData;
    hrData?: HrData;
};

export const MatchDebug: React.FC<MatchDebugProps> = ({
    match,
    hrData,
    gpsData,
}) => {
    return (
        <table>
            <tbody>
                <tr>
                    <td>Match ID</td>
                    <td>{match._id}</td>
                </tr>
                <tr>
                    <td>Revision</td>
                    <td>{match._rev}</td>
                </tr>
                <tr>
                    <td>Match Finished</td>
                    <td>{match.matchFinished ? "Yes" : "No"}</td>
                </tr>
                <tr>
                    <td>Has Tracking</td>
                    <td>{match.hasTracking ? "Yes" : "No"}</td>
                </tr>
                <tr>
                    <td>GPS Processed</td>
                    <td> {match.stats?.gpsProcessed === 1 ? "Yes" : "No"}</td>
                </tr>
                <tr>
                    <td>Has Heart Rate</td>
                    <td>{match.hasHeartRate ? "Yes" : "No"}</td>
                </tr>
                <tr>
                    <td>HR Processed</td>
                    <td>
                        {" "}
                        {match.stats?.heartRateProcessed === 1 ? "Yes" : "No"}
                    </td>
                </tr>
                <tr>
                    <td>GPS Points</td>
                    <td>{gpsData?.geoPoints?.length || 0}</td>
                </tr>
                <tr>
                    <td>HR Points</td>
                    <td>{hrData?.heartRateValues?.length || 0}</td>
                </tr>
            </tbody>
        </table>
    );
};
